/**
 * @param {string} accno - The account number to format.
 * @param {boolean} showfullaccno - Whether to show the full account number or mask it.
 * @param {boolean} showVirtualFormat - Whether to show the full account number or mask it.
 * @returns {string} The formatted account number string.
 */
export const standardAccountNumberFormat = (
  accno,
  showfullaccno,
  showVirtualFormat,
) => {
  if (showfullaccno) {
    return accno
      ?.split("")
      ?.reverse()
      ?.join("")
      ?.replace(/(.{4})/g, "$1 ")
      ?.split("")
      ?.reverse()
      ?.join("")
      ?.trim();
  }
  if (showVirtualFormat) {
    return `•••• ${accno?.substring(accno?.length - 4)}`;
  }
  if (accno?.length <= 8 || typeof accno !== "string") {
    return `${accno?.substring(0, 4)} ${accno?.substring(4)}`;
  }

  if (isNaN(Number(accno))) {
    return `•••• ${accno?.substring(accno.length - 4)}`;
  } else {
    return `${accno?.substring(0, 4)} •••• ${accno?.substring(accno.length - 4)}`;
  }
};
